import { render, staticRenderFns } from "./coursePriceList.vue?vue&type=template&id=14290159&"
import script from "./coursePriceList.vue?vue&type=script&lang=js&"
export * from "./coursePriceList.vue?vue&type=script&lang=js&"
import style0 from "./coursePriceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports